var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none']},[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id
    },false)):_vm._e(),(_vm.readOnly || _vm.disabled)?_c('RichContent',{attrs:{"content":_vm.valueOrPlaceholder}}):_c('PageEditor',{staticClass:"w-100 border p-2 rounded-5",attrs:{"content":_vm.value || '',"config":_vm.config,"iteration":_vm.iteration},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }